
const SettingsPage = () => {
    return (
        <div className="flex items-center justify-center bg-slate-200">Settings Page</div>
    )
}

export default SettingsPage